import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24a8deb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mt-5" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "pt-5" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "col-12 mt-3 space-x-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, [
          _createTextVNode(" Căn cứ theo quyết định của Giám đốc "),
          (_ctx.showGiamDocInput)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _createVNode(_component_el_form_item, {
                  prop: "giam_doc",
                  class: "d-inline-block"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.localGiamDocName,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localGiamDocName) = $event)),
                      disabled: !_ctx.isEditable,
                      placeholder: "Mời nhập tên",
                      name: "giam_doc"
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(" về việc thành lập hội đồng kiểm nghiệm. Hội đồng kiểm nghiệm gồm các ông (bà) có tên sau đây: ")
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_table, {
          size: "medium",
          border: true,
          data: _ctx.hoiDongKiemNghiem,
          "row-class-name": "non-striped__row"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "STT",
              width: "50"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.thuTu), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Họ và tên" }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_input, {
                  "model-value": _ctx.hoiDongKiemNghiem[scope.$index].hoTen,
                  disabled: !_ctx.isEditable,
                  onInput: (value) => _ctx.updateField(scope.$index, 'hoTen', value)
                }, null, 8, ["model-value", "disabled", "onInput"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Chức vụ chuyên môn" }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_input, {
                  "model-value": _ctx.hoiDongKiemNghiem[scope.$index].chucVu,
                  disabled: !_ctx.isEditable,
                  onInput: 
                  (value) => _ctx.updateField(scope.$index, 'chucVu', value)
                
                }, null, 8, ["model-value", "disabled", "onInput"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Thành phần trong hội đồng" }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_input, {
                  "model-value": _ctx.hoiDongKiemNghiem[scope.$index].thanhPhan,
                  disabled: !_ctx.isEditable,
                  onInput: 
                  (value) => _ctx.updateField(scope.$index, 'thanhPhan', value)
                
                }, null, 8, ["model-value", "disabled", "onInput"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_ButtonCustom, {
            "button-type": _ctx.ButtonsType.ADD,
            "is-disabled": !_ctx.isEditable,
            "tooltip-message": "Thêm thành phần trong h/đồng kiểm nghiệm",
            onClick: _ctx.onAddNguoiKiemNghiem
          }, null, 8, ["button-type", "is-disabled", "onClick"]),
          _createVNode(_component_ButtonCustom, {
            "button-type": _ctx.ButtonsType.MINUS,
            "color-type": _ctx.ButtonTypeColors.DANGER,
            "is-disabled": _ctx.hoiDongKiemNghiem.length === 1 || !_ctx.isEditable,
            "tooltip-message": "Xoá thành phần trong h/đồng kiểm nghiệm",
            onClick: _ctx.onDeleteNguoiKiemNghiem
          }, null, 8, ["button-type", "color-type", "is-disabled", "onClick"])
        ])
      ])
    ])
  ]))
}